import { WrapLocaleReceiver } from '../I18N';
import React, { useState } from 'react';
import { Drawer, Button, Alert } from 'tntd';
import ReferenceInfo from '../ReferenceInfo';

export default WrapLocaleReceiver((props) => {
    const {
        resolve,
        type,
        canNextOpera,
        modalWrap,
        referenceData,
        removeModal,
        title,
        orgMap = {},
        appList = [],
        cancelText,
        okText,
        emptyType,
        showPagination,
        destroyOnClose = true,
        jumpFun,
        iframeJump,
        weakMsg,
        strongMsg,
        I18N
    } = props || {};

    const [visible, setVisible] = useState(true);

    return (
        <Drawer
            title={title || I18N.referencecheck.index.yinYongGuanXiCha}
            visible={visible}
            width={1000}
            destroyOnClose={destroyOnClose}
            getContainer={modalWrap}
            onCancel={()=>setVisible(false)}
            afterVisibleChange={(vi)=>{
                if(!vi){
                    removeModal()
                }
            }}
            showFooter={!!canNextOpera}
            footer={canNextOpera?[
                <Button key="back" onClick={()=>setVisible(false)}>
                    {cancelText || I18N.referencecheck.index.quXiao}
                </Button>,
                canNextOpera && (
                    <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                        setVisible(false);
                        resolve(type);
                    }}
                    >
                    {okText || I18N.referencecheck.index.xiaYiBu}
                    </Button>
                ),
            ]:null}
        >
            <div className="reference-check-drawer">
                {canNextOpera && (
                    <div className="mb16">
                    <Alert
                        type="warning"
                        message={
                        weakMsg || referenceData?.message ||  I18N.referencecheck.index.cunZaiRuoYinYong
                        }
                    />
                    </div>
                )}
                {!canNextOpera && (
                    <div className="mb16">
                    <Alert
                        type="error"
                        message={
                        strongMsg || referenceData?.message || I18N.referencecheck.index.cunZaiQiangYinYong
                        }
                    />
                    </div>
                )}
                <div className="relation-reference-detail">
                    <ReferenceInfo
                        jumpFun={jumpFun}
                        iframeJump={iframeJump}
                        showPagination={showPagination}
                        emptyType={emptyType}
                        referenceData={referenceData}
                        orgMap={orgMap}
                        appList={appList}
                        unmountHandle={removeModal}
                    />
                </div>
            </div>
        </Drawer>
    )
});
